<template>
    <div :class="['menu-content', { active: showMenu }]">
        
        <!-- Hook top -->
        <component
        v-for="(componente,i) in componentes.menuTop"
        :key="i"
        :is="componente.componente"
        v-bind="componente.props"
        v-on="componente.events"/>

        <!-- Menu -->
        <div class="menu-header">
            <!--<img class="logo" src="@c/assets/img/llorente-o.svg" alt="DMS">-->
            
            <el-dropdown trigger="click" v-if="user && user.usuario">
                <span class="el-dropdown-link">
                    <i class="el-icon-user-solid"></i> {{user.usuario}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="el-icon-user">Perfil</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-switch-button" @click.native="logout()">Desconectar</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <el-menu :collapse="true" v-if="user && user.menu && user.menu.length">

                <el-submenu index="1">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                    </template>
                    <el-submenu v-for="(item,i) in user.menu" :key="i" :index="`1-${i}`">
                        <span slot="title">{{item.name}}</span>
                        <el-menu-item v-for="(option,o) in item.options" :key="o" :index="`1-${i}-${o}`" @click="goMenu(option.link)">{{option.name}}</el-menu-item>
                    </el-submenu>
                </el-submenu>

            </el-menu>
        </div>

        <!-- Acciones -->
        <el-menu default-active="2" :collapse="isCollapse">

            <!-- Buscador -->
            <el-menu-item-group >
                <span slot="title">General</span>
                <el-menu-item index="1-1" @click="$emit('openSearch')">
                    <i class="el-icon-search"></i> <span slot="title">Buscador</span>
                </el-menu-item>
            </el-menu-item-group>

            <!-- Acciones -->
            <el-menu-item-group v-if="actions && actions.length">
                <span slot="title">Acciones</span>
                <el-menu-item index="1-1" v-for="(action,i) in actions" :key="i" @click="clickAction(action)">
                    <i class="el-icon-arrow-right"></i> <span slot="title">{{action.titulo}}</span>
                </el-menu-item>
            </el-menu-item-group>
            
        </el-menu>

        <!-- Hook bottom -->
        <component
        v-for="(componente,i) in componentes.menuBottom"
        :key="i"
        :is="componente.componente"
        v-bind="componente.props"
        v-on="componente.events"/>

    </div>
</template>

<script>
	export default {
        name: 'MenuPrincipal',
        props: {
            id: [Number,String],
			showMenu: Boolean,
			ficha: Object,
			elementosCajon: Object,
			initialSearch: Object,
			initialDetailOpenTab: String,
			user: Object,
			selectedItem: Number,
            descargar: Function,
            componentes: Object
		},
        data() {
            return {
                isCollapse: false,
                // Opciones
                hover: null,
				showPanel: false,
            };
        },
        computed: {

			actions () { 
                
                return  (this.ficha && this.ficha.menu && this.ficha.menu.acciones) ? this.ficha.menu.acciones.map(accion => {
                    let m = this.ficha.actions[accion]
                    return {
                        icon: m.icon,
                        titulo: m.titulo,
                        auto: m.auto || true,
                        url: m.url ? m.url.replace('@@id@@',this.id) : null
                    }
                }) : []
            }

		},
        methods: {
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            },
            // Panel left
			closePanel () { this.showPanel = false },
			clickO () { location.href = '/' },
			logout () {
                console.log('logout!')
                this.$confirm('¿Seguro que desea cerrar sesión?', 'Desconectar', {
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {
                    localStorage.removeItem('accessToken')
                    window.location.reload(true)
                })
            },

            // Acciones
            async clickAction(action) {
                this.$emit('clickAction', action)
            },

            // Abrir enlace del menu
            goMenu(link) {
                this.openwindow(link,'_blank')
            }
        }
	}
</script>

<style lang="scss">
.menu-content {
    width: 90%;
    .menu-header {
        width: auto;
        display: flex;
        flex-flow: column;
        align-items: center;
        padding: 40px 15px 15px 15px;
        margin-bottom: 15px;
        position: relative;
        ul.el-menu {
            position: absolute;
            top: 0;
            right: 0;
        }
        .el-dropdown-link {
            cursor: pointer;
        }
        img {
            width: 60px;
            margin-bottom: 10px;
        }
    }
    /*.menu-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        > ul.el-menu {
            display: flex;
            align-items: center;
            width: auto;
            li {
                margin-left: 4px;
                &.el-submenu {
                    width: fit-content;
                    .el-submenu__title {
                        height: fit-content;
                        line-height: 1;
                        padding: 5px 2px!important;
                        &:hover {
                            background-color: white;
                        }
                    }
                }
                &.el-menu-item-group {
                    > ul > li.el-menu-item {
                        height: fit-content;
                        width: fit-content;
                        line-height: 1;
                        padding: 5px 2px!important;
                    }
                    .el-menu-item-group__title {
                        padding: 0px!important;
                    }
                }
            }
        }
        .logo {
            width: 50px;
            padding: 30px 20px;
        }
    }*/
    
    a {
        text-decoration: none;
        color: inherit;
    }
    
    .el-menu {
        background-color: transparent;
        border: 0px;
        li.el-menu-item {
            color: #4a596a;
            i {
                color: #4a596a;
            }
        }
        .el-menu-item:focus, .el-menu-item:hover {
            outline: 0;
            background-color: #ffffff;
        }
    }
}
</style>